import { combineReducers } from "redux";

import userReducer from "./auth";
import sideMenuReducer from "./sideMenu";

export default combineReducers({
  user: userReducer,
  sideMenuReducer,
});
